import { useEffect, useRef, useState } from "react";
import cx from "classnames";

import PlusIcon from "resources/icons/plus.svg";
import MinusIcon from "resources/icons/minus.svg";

import styles from "./AccordionItem.module.scss";

export interface AccordionItemData {
  id: string;
  title: string;
  content: React.ReactNode;
}

interface AccordionItemProps {
  item: AccordionItemData;
  index: number;
  isOpen: boolean;
  onToggle: (index: number) => void;
}

const AccordionItem = ({
  item,
  index,
  isOpen,
  onToggle,
}: AccordionItemProps) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState<number>(0);

  useEffect(() => {
    if (!contentRef.current) return;

    if (isOpen) {
      const contentHeight = contentRef.current.scrollHeight;
      setHeight(contentHeight);
    } else {
      setHeight(0);
    }
  }, [isOpen]);

  const buttonId = `${item.id}-button`;
  const panelId = `${item.id}-panel`;

  return (
    <div className={styles.item}>
      <button
        id={buttonId}
        className={styles.button}
        onClick={() => onToggle(index)}
        aria-expanded={isOpen}
        aria-controls={panelId}
        type="button"
      >
        <span className={styles.title}>{item.title}</span>

        {isOpen ? (
          <MinusIcon className={styles.icon} />
        ) : (
          <PlusIcon className={cx(styles.icon, styles.active)} />
        )}
      </button>
      <div
        id={panelId}
        ref={contentRef}
        className={styles.content}
        style={{ height: height }}
        aria-labelledby={buttonId}
        aria-hidden={!isOpen}
        role="region"
      >
        <div className={styles.inner}>{item.content}</div>
      </div>
    </div>
  );
};

export default AccordionItem;
